// src/admin/pages/AddImage.tsx
import { useState } from "react";
import { Image, ImagePlus, Link, Save, Loader2 } from "lucide-react";

const AddImage = () => {
  const [activeTab, setActiveTab] = useState<'file' | 'link'>('file');
  const [title, setTitle] = useState("");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [linkUrl, setLinkUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  // const backendUrl = "http://localhost:1415";
  // const backendUrl = "http://localhost/seva-backend";
  const backendUrl = "https://www.sevaafoundation.com/seva-backend";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");
    const token = localStorage.getItem("sevaa_admin_token");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("type", "image");
    formData.append("storage_type", activeTab);

    if (activeTab === 'file') {
      if (!imageFile) { setMessage("Please select an image file."); setIsLoading(false); return; }
      formData.append("image_file", imageFile);
    } else {
      if (!linkUrl) { setMessage("Please enter a link URL."); setIsLoading(false); return; }
      formData.append("link_url", linkUrl);
    }

    try {
      const response = await fetch(`${backendUrl}/api/media/add.php`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setMessage("Image added successfully to library!");
        setTitle(""); setImageFile(null); setLinkUrl("");
      } else { setMessage(data.error); }
    } catch (err) { setMessage("Network error occurred."); }
    finally { setIsLoading(false); }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-8 border-b pb-6">
        <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center"><ImagePlus size={24}/></div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Add New Image</h1>
          <p className="text-slate-500 text-sm">Upload image files or add external social media links</p>
        </div>
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
        <div className="flex gap-2 mb-8 p-1 bg-slate-50 rounded-xl max-w-md">
          {['file', 'link'].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab as any)} className={`flex-1 px-4 py-3 rounded-lg flex items-center justify-center gap-2 font-semibold text-sm transition-colors ${activeTab === tab ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"}`}>
              {tab === 'file' ? <Image size={16}/> : <Link size={16}/>} Upload Image File
            </button>
          ))}
        </div>

        {message && <div className="mb-6 p-4 bg-orange-50 text-orange-700 rounded-lg text-sm font-medium">{message}</div>}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Image Title</label>
            <input required type="text" value={title} onChange={e => setTitle(e.target.value)} className="w-full px-4 py-3 bg-slate-50 border rounded-xl outline-none focus:border-orange-500" placeholder="e.g. Field Visit Photos March" />
          </div>

          {activeTab === 'file' ? (
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Upload Image File (JPG, PNG, WEBP)</label>
              <input type="file" accept="image/*" onChange={e => e.target.files && setImageFile(e.target.files[0])} className="w-full p-2.5 border-2 border-dashed rounded-xl" />
            </div>
          ) : (
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">External Image Link URL</label>
              <div className="relative">
                <Image size={18} className="absolute left-4 top-4 text-slate-400" />
                <input required type="url" value={linkUrl} onChange={e => setLinkUrl(e.target.value)} className="w-full pl-12 pr-4 py-3.5 bg-slate-50 border rounded-xl outline-none focus:border-orange-500" placeholder="Paste direct image link or social media post link here..." />
              </div>
            </div>
          )}

          <div className="pt-4 border-t"><button type="submit" disabled={isLoading} className="bg-slate-900 text-white px-8 py-3.5 rounded-xl font-semibold flex items-center gap-2 hover:bg-slate-800 disabled:bg-slate-400">
            {isLoading ? <><Loader2 className="animate-spin" size={18}/> Processing...</> : <><Save size={18}/> Add to Library</>}
          </button></div>
        </form>
      </div>
    </div>
  );
};
export default AddImage;